import React from 'react';
import { useObserverReturningStore } from '../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../Legacy';
import { useResolve } from '../Container';
import { PassportModel, PermissionCode } from '../PassportModel';

// const enable = {};
// const disable = {
//     opacity: .66,
//     pointerEvents: 'none',
//     userSelect: 'none',
//     filter: 'blur(.125rem)',
// };

export const usePermissionCheck = (...codes: PermissionCode[]) => {
    return useObserverReturningStore(useResolve(PassportModel)).verify(...codes);
};

export const usePermissions = (...codes: PermissionCode[]) => {
    const store = useObserverReturningStore(useResolve(PassportModel));
    return codes.map(code => store.verify(code));
};

export const ShowIfHasPermission: LFC<{ requires: PermissionCode | PermissionCode[] }> = ({ requires, children }) => {
    requires = Array.isArray(requires) ? requires : [requires];
    const has = usePermissionCheck(...requires);
    return <>{has && children}</>;
};

type CodeInput = PermissionCode | PermissionCode[];

export const HideIfHasPermission: LFC<{ any?: CodeInput, all?: CodeInput }> = ({ any, all, children }) => {
    any = Array.isArray(any) ? any : (!!any ? [any] : []);
    all = Array.isArray(all) ? all : (!!all ? [all] : []);
    const passport = useObserverReturningStore(useResolve(PassportModel));
    const has = (
        !!any.find(x => passport.verify(x)) ||
        all.length > 0 && passport.verify(...all)
    );
    return <>{!has && children}</>;
};
